<template>
  <div id="frontPage">
    <p id="slogan">Dedicated to helping get your project off the ground</p>
    <!--<div id="partners">
      <PartnerContainer/>
    </div>-->
    <div id="globe">
      <video autoplay muted>
        <source :src="require('@/assets/CloseUpGlobeSpin.mp4')" type="video/mp4"/>
      </video>
    </div>
  </div>
</template>

<script>
import PartnerContainer from '@/components/PartnerContainer'

export default {
  name: 'FrontPage',
  components: {
    PartnerContainer
  }
}
</script>

<style>
  #slogan {
    text-align: center;
    font-size: 1.25em;
    padding-top: 25px;
    margin-bottom: 50px;
  }
  #frontPage #globe {
    width: 100%;
  }
  #globe video {
    width: 100%;
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FrontPage.vue